function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "notes-edit",
  transform: "translate(-0.248 -0.242)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_6580",
  "data-name": "Path 6580",
  d: "M18.33,13.494l-4.747,4.747-2.333.467.467-2.333,4.747-4.747a1.317,1.317,0,0,1,1.862,0l0,.006a1.315,1.315,0,0,1,0,1.861Z",
  transform: "translate(-3.967 -3.967)",
  fill: "none",
  stroke: "#03ade8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_6581",
  "data-name": "Path 6581",
  d: "M5.416,13.441H1.683a.911.911,0,0,1-.933-.933V3.242a.969.969,0,0,1,.933-1h9.333a.969.969,0,0,1,.933,1V5.975",
  transform: "translate(0 -0.567)",
  fill: "none",
  stroke: "#03ade8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_67",
  "data-name": "Line 67",
  y2: 3,
  transform: "translate(3.749 0.742)",
  fill: "none",
  stroke: "#03ade8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_68",
  "data-name": "Line 68",
  y2: 3,
  transform: "translate(6.749 0.742)",
  fill: "none",
  stroke: "#03ade8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("line", {
  id: "Line_69",
  "data-name": "Line 69",
  y2: 3,
  transform: "translate(8.749 0.742)",
  fill: "none",
  stroke: "#03ade8",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}));

var SvgEditBlue = function SvgEditBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15.001,
    height: 14.999,
    viewBox: "0 0 15.001 14.999",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEditBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit_blue.fe1f3696.svg";
export { ForwardRef as ReactComponent };